/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Label_NameInputs */

const fr_account_label_name = /** @type {(inputs: Account_Label_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Établissement`)
};

const en_account_label_name = /** @type {(inputs: Account_Label_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Property`)
};

/**
* | output |
* | --- |
* | "Property" |
*
* @param {Account_Label_NameInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const account_label_name = /** @type {((inputs?: Account_Label_NameInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Label_NameInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_account_label_name(inputs)
	return en_account_label_name(inputs)
});